import { useState } from 'react'

const STORAGE_KEY = 'soundcheck_role'

export function useRole() {
  const stored = localStorage.getItem(STORAGE_KEY)
  const [role, setRoleState] = useState(stored || 'prep')
  const [isExplicit, setIsExplicit] = useState(!!stored)

  function setRole(newRole) {
    localStorage.setItem(STORAGE_KEY, newRole)
    setRoleState(newRole)
    setIsExplicit(true)
  }

  return { role, setRole, isExplicit }
}
